import { InfoForNodes } from 'views/Labs/InfoForNodes/InfoForNodes';
import { UserNodes } from 'views/Labs/UserNodes/UserNodes';
// import { UserLabs } from 'views/Labs/UserLabs/UserLabs'
// import { LabsEnroll } from 'views/Labs/LabsEnroll/LabsEnroll';
import { LabQuiz } from 'views/Labs/LabQuiz/LabQuiz';
import { NodeQuiz } from 'views/Labs/QuizForNode/QuizForNode';
import { NodeRouter } from 'views/Labs/NodeRouter/NodeRouter';
import { QuizInstructions } from 'views/Labs/LabQuiz/QuizInstructions';
import UserManualLabs from 'views/Labs/UserManualLabs/UserManualLabs';
// import { LabsPurchase } from '../views/Labs/LabsPurchase/LabsPurchase';
import { UserLabReport } from 'views/Labs/UserLabReport/UserLabReport';
import { LabInfo } from 'views/Labs/LabsPurchase/LabInfo';
// import { LabsOrgPurchase } from 'views/Labs/LabsOrgPurchase/LabsOrgPurchase';
import { LabsView } from 'views/Labs/LabsView';


const routes = [
    {
        path: '/labs',
        view: LabsView,
        layout: 'app',
        permission: 'labs.view',
        title: 'Labs.UserLabs.title',
    },
    {
        path: '/labs/:lab_id/nodes',
        view: UserNodes,
        layout: 'app',
        permission: 'labs.nodes.view',
        title: 'Labs.UserNodes.title.default'
    },
    {
        path: '/labs/:lab_id/local',
        view: UserManualLabs,
        layout: 'app',
        permission: 'labs.local.view',
        title: 'Labs.UserManualLabs.title'
    },
    {
        path: '/labs/:lab_id/nodes/:node_id',
        view: InfoForNodes,
        layout: 'app',
        permission: 'labs.node.view',
        title: 'Labs.InfoForNodes.title'
    },
    {
        path: '/labs/:lab_id/nodes/:node_id/:resource',
        view: NodeRouter,
        layout: 'appPlain',
        permission: 'labs.node.view',
        title: 'Module'
    },
    // {
    //     path: '/labs/org',
    //     view: LabsOrgPurchase,
    //     layout: 'app',
    //     permission: 'scholar',
    //     title: 'Labs.LabsEnroll.title'
    // },
    // {
    //     path: '/labs/purchase',
    //     view: LabsPurchase,
    //     layout: 'app',
    //     permission: 'scholar',
    //     title: 'Labs.LabsPurchase.title'
    // },
    {
        path: '/labs/info/:lab_id',
        view: LabInfo,
        layout: 'app',
        permission: 'labs.info.view',
        title: 'Labs.LabInfo.title.buy'
    },
    // {
    //     path: '/labs/enroll/:lab_id',
    //     view: LabInfo,
    //     layout: 'app',
    //     permission: 'scholar',
    //     title: 'Labs.LabInfo.title.buy'
    // },
    {
        path: '/labs/:lab_id/quiz/start',
        view: QuizInstructions,
        layout: 'app',
        permission: 'labs.quiz.view',
        title: 'Labs.QuizInstructions.title'
    },
    {
        path: '/labs/:lab_id/quiz/:context',
        view: LabQuiz,
        layout: 'app',
        permission: 'labs.quiz.view',
        title: 'Labs.LabQuiz.title'
    },
    {
        path: '/labs/:lab_id/nodes/:node_id/quiz/:context',
        view: NodeQuiz,
        layout: 'app',
        permission: 'labs.nodequiz.view',
        title: 'Labs.QuizForNode.title'
    },
    {
        path: '/labs/:lab_id/report',
        view: UserLabReport,
        layout: 'appPlain',
        permission: 'labs.report.view',
        title: 'Labs.UserLabReport.title'
    },
];

export default routes;